module.exports = __webpack_public_path__ + "img/gitlab.1dfd60f9.png";